<template>
    <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                           :titleLabel="$t('profile.label.login_notify.title')"
                           :parentScreen="parentScreen">
        <div class="alert alert-warning">
            {{$t('profile.label.login_notify.note1')}} <br>
            {{$t('profile.label.login_notify.note2')}}
        </div>
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.email')}}</label>
            <div class="col-md-6">
                <div class="checkboxThree">
                    <input type="checkbox"
                           @change="changeLoginNotifyMainMail(input)"
                           v-model="$v.input['amsCustomerDetail.loginNotifyMainMailFlg'].$model"
                           name="loginNotifyMainMailFlg"
                           :disabled="this.profileState.disabledLoginNotifyMainMail"
                           true-value="1"
                           false-value="0"
                           id="ckLoginNotifyMainMail">
                    <label for="ckLoginNotifyMainMail"></label>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.additional_email')}}</label>
            <div class="col-md-6">
                <div class="checkboxThree">
                    <input type="checkbox"
                           @change="changeLoginNotifyAdditionalMail(input)"
                           v-model="$v.input['amsCustomerDetail.loginNotifyAdditionalMailFlg'].$model"
                           name="loginNotifyAdditionalMailFlg"
                           :disabled="this.profileState.disabledLoginNotifyAdditionalMail"
                           true-value="1"
                           false-value="0"
                           id="ckLoginNotifyAdditionalMail">
                    <label for="ckLoginNotifyAdditionalMail"></label>
                </div>
            </div>
        </div>
        <template v-if="this.isParentScreenEditProfile">
            <div class="form-action">
                <button class="btn btn-sm btn-submit btn-success mr-2"
                        :disabled="isDisabledButtonSubmit"
                        :type="this.getButtonType()">
                    {{$t('profile.label.screen.2fa.save')}}
                </button>
                <button class="btn btn-default btn-cancel btn-sm"
                        type="button"
                        @click="reverseInput">
                    {{$t('profile.button.cancel')}}
                </button>
            </div>
        </template>
    </ForceNewsBlockWrapper>
</template>
<script>
    import formMixin from '@/common/mixins/form';
    import {createNamespacedHelpers} from 'vuex';

    const {mapState: mapProfileState, mapActions: mapProfileActions} = createNamespacedHelpers("editProfile");
    export default {
        name: "UpdateLoginNotify",
        props: {},
        data() {
            return {}
        },
        mixins: [formMixin],
        methods: {
            ...mapProfileActions(['changeLoginNotifyMainMail', 'changeLoginNotifyAdditionalMail']),
        },
        validations() {
            return {
                input: {
                    'amsCustomerDetail.loginNotifyMainMailFlg': {},
                    'amsCustomerDetail.loginNotifyAdditionalMailFlg': {}
                },
            }
        },
        computed: {
            ...mapProfileState({
                profileState: state => state,
            })
        },
    }
</script>

<style scoped>

</style>
